module.exports = __webpack_public_path__ + "img/occidental-hotel-3.1ff3c937.jpg";